/* eslint-disable */ export default {
  WS_BASE_URL: "https://api.mloukproductions.com/items/",
  WS_STORAGE_URL: "https://api.mloukproductions.com/assets/",
};
